import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useMutation, } from "react-query";
import { useHistory } from "react-router-dom";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import { DeleteNotice } from "../../services/supplierNotice.service";
import { ApiResultModel } from "../../models/common.model";
import { ShowItemRequest } from "../../models/supplierNotice.model";

const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalRemoveSupplierNotice({ openModel, noticeKey, canEdit, noticesData, setNoticesData }: any) {
    const [open, setOpen] = React.useState<boolean>(openModel);
    React.useEffect(() => {
        setOpen(openModel);
    }, [openModel]);

    const history = useHistory();
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const removeSupplierNoticeMutation = useMutation(
        DeleteNotice,
        {
            onSuccess: (data: ApiResultModel<boolean>) => {
                if (data.data) {
                    handleClose();
                    setNoticesData(noticesData.filter((item: any) => item.noticeKey != noticeKey));
                    //history.push("/setting/notificationList");
                }
            },
        }
    );
    const handelVerify = () => {
        const noticeItem: ShowItemRequest = { noticeKey: noticeKey, isVisited: undefined }
        removeSupplierNoticeMutation.mutate(noticeItem);
    };
    const handelCancel = () => {
        handleClose();
    };

    return (
        <>
            <DeleteOutlined
                onClick={canEdit ? handleOpen : () => { }}
                scale="scale(1.8) "
                className={`${canEdit ? " enableMoreHorizIcon cursorPointer" : " disableMoreHorizIcon "}`}
            // onClick={() => handleDeleteNoticeItem(row.noticeKey)}
            />


            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <Box
                    sx={style}
                    style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
                    className="ModalCmp textCenter "
                >
                    <div>
                        <Typography className="textCenter mTop30 mbottom20">
                            آیا از{" "}
                            <b className="colorCancel">
                                حذف اطلاعیه
                            </b>{" "}
                            اطمینان دارید؟
                        </Typography>
                    </div>
                    <Grid container spacing={2} columns={16} className="mTop20">
                        <Grid item xs={8}>
                            <Button
                                onClick={handelVerify}
                                fullWidth
                                className="btnForm SuccessDefault"
                            >
                                بله
                            </Button>
                        </Grid>
                        <Grid item xs={8}>
                            <Button
                                onClick={handelCancel}
                                fullWidth
                                className="btnForm DangerDefault"
                            >
                                خیر
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
}
